import { defineMessages } from 'react-intl';

const messages = defineMessages({
  Inapplicable: 'Inapplicable',
  Blocked: 'Blocked',
  Software: 'Software',
  SoftwareType: 'SoftwareType',
  OtherSoftware: 'OtherSoftware',
  SendInvoiceSoftware: 'SendInvoiceSoftware',
  ExportToExcel: 'Export to Excel',
  ExportToExcelStarted: 'Export to Excel started',
  NoJobsFound: 'No jobs found',
  JobType: 'Job type',
  CreatedAt: 'Creation date',
  CreatedBy: 'Created by',
  JobStatus: 'Status',
  SyncType: 'Sync type',
  ConnectPlatform: 'Connect Platform',
  Entity: 'Entity',
  CompletedAt: 'Completion date',
  OpenDetail: 'Open details',
  Relation: 'Relation',
  Errors: 'Errors',
  ModifiedAt: 'Modified date',
  JobDetails: 'Job details',
  CompletedItems: 'Completed items',
  FailedItems: 'Failed items',
  Relations: 'Relations',
  NumberOfItems: 'Number of items',
  GlobalActions: 'Global actions',
  Synchronizations: 'Synchronizations',
  Task: 'Task',
  Tasks: 'Tasks',
  Subtask: 'Subtask',
  Status: 'Status',
  SendEmail: 'Send email',
  Yes: 'Yes',
  No: 'No',
  Field: 'Field',
  Value: 'Value',
  StartPlanning: 'Start planning',
  EndPlanning: 'End planning',
  TaskTemplate: 'Task template',
  ExecutionDuration: 'Expected duration',
  ResetToTemplateValue: 'Reset to the task template value',
  OnlyMainTask: 'Only the main task',
  ApplyToTaskboard: 'Apply to the open tasks on the taskboard',
  Schedule: 'Schedule',
  Authorization: 'Authorization',
  Authorizations: 'Authorizations',
  Info: 'Info',
  SkippedItems: 'Skipped items',
  Registration: 'Registration',
  Registrations: 'Registrations',
  Date: 'Date',
  Quantity: 'Quantity',
  MinutesLowerCase: 'minutes',
  What: 'What',
  Remark: 'Remark',
  StartTime: 'Start time',
  Billable: 'Billable',
  InternalRemark: 'Internal remark',
  NoSchedule: 'No schedule',
  Amount: 'Amount',
  LedgerAccount: 'Ledger account',
  OverrideExistingSchedule: 'Override existing schedule if present.',
  Invoice: 'Invoice',
  Invoices: 'Invoices',
  MailTemplate: 'Mail template',
  OpenRelation: 'Open relation file',
  OpenInvoice: 'Open invoice',
  Subject: 'Subject',
  Attachments: 'Attachments',
  DeletePlannedTasks: 'Delete planned tasks',
  Document: 'Document',
  Documents: 'Documents',
  Transaction: 'Transaction',
  Transactions: 'Transactions',
  DraftInvoice: 'Draft invoice',
  DraftInvoices: 'Draft invoices',
  PlannedRegistrations: 'Planned registrations',
  PlannedRegistration: 'Planned registration',
  DateFrom: 'From',
  DateUntil: 'Until',
  JobEntryStatus: 'Job entry status',
  ResetFilters: 'Reset filters',
  Search: 'Search',
  SearchInfo: 'Search info',
  Tags: 'Tags',
  Employees: 'Employees',
  Employee: 'Employee',
  Year: 'Year',
  Resource: 'Resource',
  CopyFromPreviousYear: 'Copy from previous year',
  AbsenceStartValue: 'Start value',
  OverrideIfCounterAlreadyExists: 'Override if counter already exists',
  RemoveExistingCorrections: 'Remove existing corrections',
  Hours: 'Hours',
  PriceGrid: 'Price grid',
  All: 'All',
  Default: 'Default',
  PriceProfile: 'Price profile',
  Method: 'Method',
  Percentage: 'Percentage',
  PriceListItems: 'Price list items',
  PriceListItem: 'Price list item',
  InvoiceSchedule: 'Invoice schedule',
  InvoicingType: 'Invoicing type',
  InvoiceCreationDate: 'Invoice creation date',
  Deadline: 'Deadline',
  ReferenceYear: 'Reference year',
  RecalculateReferenceYear: 'Recalculate reference year',
  ClearReferenceYear: 'Clear reference year',
  Save: 'Save',
  DeleteSyncResult: 'Delete sync error',
  DeleteSyncResultConfirm: 'Are you sure you want to delete this sync error?',
  SyncResultDeleted: 'Sync error deleted successfully',
  UseDefaultAbsenceRelationOfEmployee: 'Use default absence relation of employee',
  Repeat: 'Repeat',
  EveryXWeeks: 'Every {weeks} week(s)',
  Duration: 'Duration',
  FullDay: 'Full day',
  XWorkingDays: '{days} working days',
  HalfDayMorning: 'Half day (morning)',
  HalfDayAfternoon: 'Half day (afternoon)',
});

export default messages;
